import React from 'react';
import { connect } from 'react-redux';
import { t } from 'i18n';

import { setActivityModalActivityProperties, setActivityModalShowRepeatsFields } from 'Actions/activityModal';

import Checkbox from 'Components/Forms/Checkbox';
import InputGroup from 'Components/Forms/InputGroup';
import Repeats from './Repeats';

const i18nOpts = { scope: 'activity_modal.form_fields.when' };

export const Scheduled = ({
  activityProperties,
  formErrors,
  showRepeatsFields,
  timeZone,
  setActivityModalActivityProperties,
  setActivityModalShowRepeatsFields,
}) => {
  return (
    <>
      <InputGroup
        name="dueAt"
        value={activityProperties.dueAt}
        label={t('date_and_time', i18nOpts)}
        errors={formErrors}
        timeZone={timeZone}
        onChange={({ target: { value } }) => {
          setActivityModalActivityProperties({
            ...activityProperties,
            dueAt: value,
          });
        }}
        component="datetime"
        className="input due_at_input"
      />

      {!showRepeatsFields && (
        <Checkbox
          checked={false}
          name="repeatsCheckbox"
          text={t('repeats', i18nOpts)}
          onChange={() => {
            // set defaults
            setActivityModalActivityProperties({
              ...activityProperties,
              frequency: 'daily',
              frequencyType: 'recurring',
              interval: 1,
              endRepeat: 'never',
            });
            setActivityModalShowRepeatsFields(true);
          }}
        />
      )}

      {showRepeatsFields && <Repeats />}
    </>
  );
};

const mapStateToProps = ({ activityModal }) => {
  const { activityProperties, formErrors, showRepeatsFields, timeZone } = activityModal;

  return {
    activityProperties,
    formErrors,
    showRepeatsFields,
    timeZone,
  };
};

const mapDispatchToProps = (dispatch) => {
  const dispatchSetActivityModalActivityProperties = (dispatch) => {
    return (activityProperties) => {
      dispatch(setActivityModalActivityProperties(activityProperties));
    };
  };

  const dispatchSetActivityModalShowRepeatsFields = (dispatch) => {
    return (showRepeatsFields) => {
      dispatch(setActivityModalShowRepeatsFields(showRepeatsFields));
    };
  };

  return {
    setActivityModalActivityProperties: dispatchSetActivityModalActivityProperties(dispatch),
    setActivityModalShowRepeatsFields: dispatchSetActivityModalShowRepeatsFields(dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Scheduled);
